export const ACTION_TYPES = Object.freeze({
    COURSE: 'course',
    INSTRUCTION: 'instructor'
});

export const PARENT_TRANSLATION_PATH = 'LearningAndDevelopmentView';

export const TRANSLATION_PATH = '';
